import { auth, payment } from '../constants/actions'

const initialState = {
  publicCert: null,
  token: null,
  loginError: { type: null, message: '' },
  loginMsg: { type: null, message: '' },
  user: {},
  signUpMsg: { type: null, message: '' },
  signUpGuestMsg: { type: null, message: '' },
  forgotPasswordMsg: { type: null, message: '' },
  resetPasswordMsg: { type: null, message: '' },
  verifyEmailMsg: { type: null, message: '' },
  verified: false,
  paymentSuccessful: true,
  isCheckingAuth: true,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case auth.SET_PUBLIC_CERT:
      return {
        ...state,
        publicCert: action.payload,
      }
    case auth.SET_TOKEN:
      return {
        ...state,
        token: action.payload,
      }
    case auth.SET_LOGIN_MSG:
      return {
        ...state,
        loginMsg: action.payload,
        loginError: null,
      }
    case auth.SET_LOGIN_ERROR:
      return {
        ...state,
        loginError: action.payload,
        loginMsg: { type: null, message: '' },
      }
    case auth.SET_SIGNUP_MSG:
      return {
        ...state,
        signUpMsg: action.payload,
      }
    case auth.SET_SIGNUP_GUEST_MSG:
      return {
        ...state,
        signUpGuestMsg: action.payload,
      }
    case auth.SET_USER:
      return {
        ...state,
        user: { ...state.user, ...action.payload },
      }
    case auth.SET_FORGOT_PASSWORD_MSG:
      return {
        ...state,
        forgotPasswordMsg: action.payload,
      }
    case auth.SET_RESET_PASSWORD_MSG:
      return {
        ...state,
        resetPasswordMsg: action.payload,
      }
    case auth.EMAIL_IS_VERIFIED:
      return {
        ...state,
        verified: true,
      }
    case auth.EMAIL_VERIFICATION_ERROR:
      return {
        ...state,
        verifyEmailMsg: action.payload,
      }
    case payment.PAYMENT_SUCCESSFUL:
      return {
        ...state,
        paymentSuccessful: action.payload,
      }
    case auth.CLEAR_USER:
      return {
        ...initialState,
        publicCert: state.publicCert,
      }
    case auth.SET_IS_CHECKING_AUTH:
      return {
        ...state,
        isCheckingAuth: action.payload,
      }
    default:
      return state
  }
}
